module.exports = __webpack_public_path__ + "static/img/service_passprime_my_prime.aea1d02a.png";